
import Triangle from "../../../assets/duotone/Triangle.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TriangleIcon({ className, dataTestid = "TriangleIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Triangle data-testid={dataTestid} className={classes} {...rest} />
  );
}
